import angular from 'angular';
import { ConnectToMpButton } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-new-mp-integration';

angular.module(moduleName, []).directive('newMpIntegrationButton', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        scope: {
            countryCode: '@',
        },
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], ConnectToMpButton, {
                country_code: _scope.countryCode
            });

            // Al destruirse, desmontar el root de React (evita fugas en body).
            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;